var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input-number',{ref:"yearStepper",staticClass:"wind-year-stepper",attrs:{"min":_vm.min,"max":_vm.max,"size":"mini"},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})
}
var staticRenderFns = []

export { render, staticRenderFns }